import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';
import {LoginService} from '../login.service';

@Component({
    selector: 'ig-auth',
    template: ''
})
export class SocialAuthComponent implements OnInit {

    constructor(
        private loginService: LoginService,
        private cookieService: CookieService,
        private router: Router,
    ) {
    }

    ngOnInit() {
        const token = this.cookieService.get('social-authentication');
        if (token.length) {
            this.loginService.loginWithToken(token, false).then((val) => {
                    this.cookieService.delete('social-authentication');
                    this.router.navigateByUrl('home');
                 }, () => {
                    this.router.navigate(['social-register'], {queryParams: {'success': 'false'}});
            });
        }
    }
}
